export default __webpack_public_path__ + "maps-examples-camera-animation-thumbnail-480-36c307044f0930b81567a28a7b8a0419.webp";